import { render, staticRenderFns } from "./BaseFormField.vue?vue&type=template&id=fb627d8e&scoped=true&"
import script from "./BaseFormField.vue?vue&type=script&lang=ts&"
export * from "./BaseFormField.vue?vue&type=script&lang=ts&"
import style0 from "./BaseFormField.vue?vue&type=style&index=0&id=fb627d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb627d8e",
  null
  
)

export default component.exports